<!--
  Vue wrapper for Bryntum ProjectModel
-->

<template>

</template>

<script>

import { AbstractCrudManager, AssignmentModel, AssignmentStore, Base, CalendarManagerStore, CalendarModel, CoreStateTrackingManager, DependencyModel, DependencyStore, EventModel, EventStore, Model, ProjectModel, ResourceModel, ResourceStore, ResourceTimeRangeModel, ResourceTimeRangeStore, SchedulerProjectModel, Store, TimeSpan } from '@bryntum/schedulerpro';

import { StringHelper } from '@bryntum/schedulerpro';
import WrapperHelper from './WrapperHelper.js';

export default {

    // eslint-disable-next-line vue/multi-word-component-names
    name : 'BryntumProjectModel',

    props : {

        // Configs only
        adjustDurationToDST            : { type : Boolean, default : undefined },
        assignmentModelClass           : { type : Function, default : undefined },
        assignmentsData                : { type : Array, default : undefined },
        assignmentStoreClass           : { type : [Function, Object], default : undefined },
        autoLoad                       : { type : Boolean, default : undefined },
        autoSync                       : { type : Boolean, default : undefined },
        autoSyncTimeout                : { type : Number, default : undefined },
        bubbleEvents                   : { type : Object, default : undefined },
        calendarManagerStoreClass      : { type : [Function, Object], default : undefined },
        calendarModelClass             : { type : Function, default : undefined },
        calendarsData                  : { type : Array, default : undefined },
        callOnFunctions                : { type : Boolean, default : undefined },
        children                       : { type : [Boolean, Array], default : undefined },
        delayCalculation               : { type : Boolean, default : undefined },
        dependenciesData               : { type : Array, default : undefined },
        dependencyModelClass           : { type : Function, default : undefined },
        dependencyStoreClass           : { type : [Function, Object], default : undefined },
        encoder                        : { type : Object, default : undefined },
        eventModelClass                : { type : Function, default : undefined },
        eventsData                     : { type : Array, default : undefined },
        eventStoreClass                : { type : [Function, Object], default : undefined },
        expanded                       : { type : Boolean, default : undefined },
        includeChildrenInRemoveRequest : { type : Boolean, default : undefined },
        listeners                      : { type : Object, default : undefined },
        maxCalendarRange               : { type : Number, default : undefined },
        orderedParentIndex             : { type : Number, default : undefined },
        pageSize                       : { type : Number, default : undefined },
        parentId                       : { type : [String, Number, null], default : undefined },
        parentIndex                    : { type : Number, default : undefined },
        phantomIdField                 : { type : String, default : undefined },
        phantomParentIdField           : { type : String, default : undefined },
        remotePaging                   : { type : Boolean, default : undefined },
        resetIdsBeforeSync             : { type : Boolean, default : undefined },
        resetUndoRedoQueuesAfterLoad   : { type : Boolean, default : undefined },
        resourceAllocationInfoClass    : { type : Object, default : undefined },
        resourceModelClass             : { type : Function, default : undefined },
        resourcesData                  : { type : Array, default : undefined },
        resourceStoreClass             : { type : [Function, Object], default : undefined },
        resourceTimeRangesData         : { type : Array, default : undefined },
        resourceTimeRangeStoreClass    : { type : [Function, Object], default : undefined },
        silenceInitialCommit           : { type : Boolean, default : undefined },
        skipSuccessProperty            : { type : Boolean, default : undefined },
        storeIdProperty                : { type : String, default : undefined },
        supportShortSyncResponse       : { type : Boolean, default : undefined },
        taskStore                      : { type : [EventStore, Object], default : undefined },
        timeRangesData                 : { type : Array, default : undefined },
        timeRangeStoreClass            : { type : [Function, Object], default : undefined },
        toJSONResultFormat             : { type : String, default : undefined },
        trackResponseType              : { type : Boolean, default : undefined },
        transport                      : { type : Object, default : undefined },
        useRawData                     : { type : Boolean, default : undefined },
        validateResponse               : { type : Boolean, default : undefined },
        writeAllFields                 : { type : Boolean, default : undefined },

        // Configs and properties
        addConstraintOnDateSet                             : { type : Boolean, default : undefined },
        assignments                                        : { type : Array, default : undefined },
        assignmentStore                                    : { type : [AssignmentStore, Object], default : undefined },
        autoCalculatePercentDoneForParentTasks             : { type : Boolean, default : undefined },
        autoMergeAdjacentSegments                          : { type : Boolean, default : undefined },
        calendar                                           : { type : [String, Object, CalendarModel], default : undefined },
        calendarManagerStore                               : { type : [CalendarManagerStore, Object], default : undefined },
        calendars                                          : { type : Array, default : undefined },
        crudStores                                         : { type : Array, default : undefined },
        daysPerMonth                                       : { type : Number, default : undefined },
        daysPerWeek                                        : { type : Number, default : undefined },
        dependencies                                       : { type : Array, default : undefined },
        dependenciesCalendar                               : { type : String, default : undefined },
        dependencyStore                                    : { type : [DependencyStore, Object], default : undefined },
        enableProgressNotifications                        : { type : Boolean, default : undefined },
        events                                             : { type : Array, default : undefined },
        eventStore                                         : { type : [EventStore, Object], default : undefined },
        forceSync                                          : { type : Boolean, default : undefined },
        hoursPerDay                                        : { type : Number, default : undefined },
        id                                                 : { type : [String, Number], default : undefined },
        ignoreRemoteChangesInSTM                           : { type : Boolean, default : undefined },
        json                                               : { type : String, default : undefined },
        lazyLoad                                           : { type : [Boolean, Object], default : undefined },
        loadUrl                                            : { type : String, default : undefined },
        readOnly                                           : { type : Boolean, default : undefined },
        remoteChildCount                                   : { type : Number, default : undefined },
        resources                                          : { type : Array, default : undefined },
        resourceStore                                      : { type : [ResourceStore, Object], default : undefined },
        resourceTimeRanges                                 : { type : Array, default : undefined },
        resourceTimeRangeStore                             : { type : [ResourceTimeRangeStore, Object], default : undefined },
        shouldSyncDataOnLoad                               : { type : Function, default : undefined },
        skipNonWorkingTimeInDurationWhenSchedulingManually : { type : Boolean, default : undefined },
        skipNonWorkingTimeWhenSchedulingManually           : { type : Boolean, default : undefined },
        stm                                                : { type : [CoreStateTrackingManager, Object], default : undefined },
        syncApplySequence                                  : { type : Array, default : undefined },
        syncUrl                                            : { type : String, default : undefined },
        timeRanges                                         : { type : Array, default : undefined },
        timeRangeStore                                     : { type : [Store, Object], default : undefined },
        timeZone                                           : { type : [String, Number], default : undefined },
        trackProjectModelChanges                           : { type : Boolean, default : undefined },

        // Properties only
        allChildren                : { type : Array, default : undefined },
        allUnfilteredChildren      : { type : Array, default : undefined },
        descendantCount            : { type : Number, default : undefined },
        hasGeneratedId             : { type : Boolean, default : undefined },
        inlineData                 : { type : Object, default : undefined },
        internalId                 : { type : Number, default : undefined },
        isCommitting               : { type : Boolean, default : undefined },
        isCreating                 : { type : Boolean, default : undefined },
        isValid                    : { type : Boolean, default : undefined },
        previousSiblingsTotalCount : { type : Number, default : undefined },
        segmentModelClass          : { type : Function, default : undefined },
        visibleDescendantCount     : { type : Number, default : undefined },

        // Events
        onBeforeDestroy        : { type : Function },
        onBeforeLoad           : { type : Function },
        onBeforeLoadApply      : { type : Function },
        onBeforeResponseApply  : { type : Function },
        onBeforeSend           : { type : Function },
        onBeforeSync           : { type : Function },
        onBeforeSyncApply      : { type : Function },
        onCatchAll             : { type : Function },
        onChange               : { type : Function },
        onCycle                : { type : Function },
        onDataReady            : { type : Function },
        onDestroy              : { type : Function },
        onEmptyCalendar        : { type : Function },
        onHasChanges           : { type : Function },
        onLoad                 : { type : Function },
        onLoadCanceled         : { type : Function },
        onLoadFail             : { type : Function },
        onNoChanges            : { type : Function },
        onProgress             : { type : Function },
        onRequestDone          : { type : Function },
        onRequestFail          : { type : Function },
        onRevisionNotification : { type : Function },
        onSchedulingConflict   : { type : Function },
        onSync                 : { type : Function },
        onSyncCanceled         : { type : Function },
        onSyncDelayed          : { type : Function },
        onSyncFail             : { type : Function },

    },

    data : () => {
        return {
            instanceClass : ProjectModel,
            instanceName : 'ProjectModel',

            configNames : [
                'adjustDurationToDST',
                'assignmentModelClass',
                'assignmentsData',
                'assignmentStoreClass',
                'autoLoad',
                'autoSync',
                'autoSyncTimeout',
                'bubbleEvents',
                'calendarManagerStoreClass',
                'calendarModelClass',
                'calendarsData',
                'callOnFunctions',
                'children',
                'delayCalculation',
                'dependenciesData',
                'dependencyModelClass',
                'dependencyStoreClass',
                'encoder',
                'eventModelClass',
                'eventsData',
                'eventStoreClass',
                'expanded',
                'includeChildrenInRemoveRequest',
                'listeners',
                'maxCalendarRange',
                'orderedParentIndex',
                'pageSize',
                'parentId',
                'parentIndex',
                'phantomIdField',
                'phantomParentIdField',
                'remotePaging',
                'resetIdsBeforeSync',
                'resetUndoRedoQueuesAfterLoad',
                'resourceAllocationInfoClass',
                'resourceModelClass',
                'resourcesData',
                'resourceStoreClass',
                'resourceTimeRangesData',
                'resourceTimeRangeStoreClass',
                'silenceInitialCommit',
                'skipSuccessProperty',
                'storeIdProperty',
                'supportShortSyncResponse',
                'taskStore',
                'timeRangesData',
                'timeRangeStoreClass',
                'toJSONResultFormat',
                'trackResponseType',
                'transport',
                'useRawData',
                'validateResponse',
                'writeAllFields'
            ],

            propertyConfigNames : [
                'addConstraintOnDateSet',
                'assignments',
                'assignmentStore',
                'autoCalculatePercentDoneForParentTasks',
                'autoMergeAdjacentSegments',
                'calendar',
                'calendarManagerStore',
                'calendars',
                'crudStores',
                'daysPerMonth',
                'daysPerWeek',
                'dependencies',
                'dependenciesCalendar',
                'dependencyStore',
                'enableProgressNotifications',
                'events',
                'eventStore',
                'forceSync',
                'hoursPerDay',
                'id',
                'ignoreRemoteChangesInSTM',
                'json',
                'lazyLoad',
                'loadUrl',
                'onBeforeDestroy',
                'onBeforeLoad',
                'onBeforeLoadApply',
                'onBeforeResponseApply',
                'onBeforeSend',
                'onBeforeSync',
                'onBeforeSyncApply',
                'onCatchAll',
                'onChange',
                'onCycle',
                'onDataReady',
                'onDestroy',
                'onEmptyCalendar',
                'onHasChanges',
                'onLoad',
                'onLoadCanceled',
                'onLoadFail',
                'onNoChanges',
                'onProgress',
                'onRequestDone',
                'onRequestFail',
                'onRevisionNotification',
                'onSchedulingConflict',
                'onSync',
                'onSyncCanceled',
                'onSyncDelayed',
                'onSyncFail',
                'readOnly',
                'remoteChildCount',
                'resources',
                'resourceStore',
                'resourceTimeRanges',
                'resourceTimeRangeStore',
                'shouldSyncDataOnLoad',
                'skipNonWorkingTimeInDurationWhenSchedulingManually',
                'skipNonWorkingTimeWhenSchedulingManually',
                'stm',
                'syncApplySequence',
                'syncUrl',
                'timeRanges',
                'timeRangeStore',
                'timeZone',
                'trackProjectModelChanges'
            ],

            propertyNames : [
                'allChildren',
                'allUnfilteredChildren',
                'descendantCount',
                'hasGeneratedId',
                'inlineData',
                'internalId',
                'isCommitting',
                'isCreating',
                'isValid',
                'previousSiblingsTotalCount',
                'segmentModelClass',
                'visibleDescendantCount'
            ],

            eventNames : [
                'beforeDestroy',
                'beforeLoad',
                'beforeLoadApply',
                'beforeResponseApply',
                'beforeSend',
                'beforeSync',
                'beforeSyncApply',
                'catchAll',
                'change',
                'cycle',
                'dataReady',
                'destroy',
                'emptyCalendar',
                'hasChanges',
                'load',
                'loadCanceled',
                'loadFail',
                'noChanges',
                'progress',
                'requestDone',
                'requestFail',
                'revisionNotification',
                'schedulingConflict',
                'sync',
                'syncCanceled',
                'syncDelayed',
                'syncFail'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps,
                processCellContent,
                processEventContent,
                hasFrameworkRenderer
            }  = WrapperHelper();

        me.instance = createWidget({
            me,
            props     : me.$props,
            data      : me.$data,
            listeners : me.$listeners,
            emit      : me.$emit.bind(me),
            element   : me.$el
        });

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
